export default {
	CREATE: "CREATE",
	IMPORT: "IMPORT",
	CHECKIN: "CHECKIN"
};
